import { Link } from "@inertiajs/react"
import type { ReactNode } from "react"

import { useAuth } from "@/hooks/use-auth"
import { newSessionPath } from "@/routes"

interface RequireAuthProps {
  children: ReactNode
  fallback?: ReactNode
}

export function RequireAuth({ children, fallback }: RequireAuthProps) {
  const auth = useAuth()

  if (!auth) {
    return (
      fallback ?? (
        <div className="flex min-h-[200px] flex-col items-center justify-center gap-4">
          <p className="text-muted-foreground">Authentication required</p>
          <Link
            href={newSessionPath()}
            className="text-primary hover:underline"
          >
            Sign in
          </Link>
        </div>
      )
    )
  }

  return <>{children}</>
}
